import { render, staticRenderFns } from "./addBankCard.vue?vue&type=template&id=95af84ce&scoped=true"
import script from "./addBankCard.vue?vue&type=script&lang=js"
export * from "./addBankCard.vue?vue&type=script&lang=js"
import style0 from "./addBankCard.vue?vue&type=style&index=0&id=95af84ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95af84ce",
  null
  
)

export default component.exports